import { useEffect, useRef } from "react";
import {
  Animated,
  ImageBackground,
  Modal,
  StyleSheet,
  TouchableOpacity,
  View,
  Image,
  ViewStyle,
  TextStyle,
  ImageStyle,
  Text,
} from "react-native";

type SvaraModalProps = {
  visible: boolean;
  onClose: () => void;
  titleImage?: any;
  title?: any;
  backgroundImage?: any;
  closeIcon: any;
  children?: React.ReactNode;
  closeButtonSize?: "small" | "big";
  closeButtonStyles?: ViewStyle;
  containerStyles?: ViewStyle;
  contentWrapperStyles?: ViewStyle;
  titleImageStyles?: ImageStyle;
  titleTextStyles?: TextStyle;
};

const SvaraModal = ({
  visible,
  onClose,
  titleImage,
  titleImageStyles,
  titleTextStyles,
  title,

  backgroundImage,
  closeIcon,
  children,
  closeButtonSize = "small",
  closeButtonStyles,
  containerStyles,
  contentWrapperStyles,
}: SvaraModalProps) => {
  const opacity = useRef(new Animated.Value(0)).current;

  useEffect(() => {
    if (visible) {
      Animated.timing(opacity, {
        toValue: 1,
        duration: 200,
        useNativeDriver: true,
      }).start();
    }
  }, [visible]);

  const handleClose = () => {
    Animated.timing(opacity, {
      toValue: 0,
      duration: 200,
      useNativeDriver: true,
    }).start(onClose);
  };

  return (
    <Modal animationType="none" transparent visible={visible}>
      <Animated.View style={{ ...styles.overlay, opacity }}>
        <ImageBackground
          source={backgroundImage}
          resizeMode="stretch"
          style={{
            borderColor: "white",
            borderWidth: 11,
            ...styles.modalBackground,
            ...containerStyles,
            backgroundColor: backgroundImage
              ? "none"
              : styles.modalBackground.backgroundColor,
          }}
        >
          <View style={styles.modalContainer}>
            {titleImage && (
              <ImageBackground
                source={titleImage}
                resizeMode="contain"
                style={[styles.titleImage, titleImageStyles]}
              >
                <Text style={[styles.text, titleTextStyles]}>{title}</Text>
              </ImageBackground>
            )}

            <TouchableOpacity
              onPress={handleClose}
              activeOpacity={0.7}
              style={[
                styles.closeButton,
                closeButtonSize === "big"
                  ? styles.bigCloseButton
                  : styles.smallCloseButton,
                closeButtonStyles,
              ]}
            >
              <Image source={closeIcon} style={styles.closeIcon} />
            </TouchableOpacity>

            <View style={[styles.content, contentWrapperStyles]}>
              {children}
            </View>
          </View>
        </ImageBackground>
      </Animated.View>
    </Modal>
  );
};

const styles = StyleSheet.create<{
  overlay: ViewStyle;
  modalBackground: ViewStyle;
  modalContainer: ViewStyle;
  titleImage: ImageStyle;
  closeButton: ViewStyle;
  smallCloseButton: ViewStyle;
  bigCloseButton: ViewStyle;
  closeIcon: ImageStyle;
  content: ViewStyle;
  modalTitle: TextStyle;
  connectText: TextStyle;
  text: TextStyle;
}>({
  overlay: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(0,0,0,0.7)",
  },
  modalBackground: {
    maxWidth: "96%",
    maxHeight: "90%",
    backgroundColor: "rgba(17, 35, 69, 0.8)",
    borderRadius: 18,
    borderWidth: 1,
    borderColor: "#00f0ff",
    padding: 2,
    paddingTop: 0,
  },

  modalContainer: {
    width: "100%",
    maxHeight: "100%",
    position: "relative",
    paddingTop: 0,
  },
  titleImage: {
    width: 300,
    height: 120,
    position: "absolute",
    top: -70,
    alignSelf: "center",
    // left: "50%",
    // transform: [{ translateX: -150 }],
  },
  closeButton: {
    position: "absolute",
    zIndex: 100,
  },
  smallCloseButton: {
    width: 22,
    height: 22,
    top: 10,
    right: 12,
  },
  bigCloseButton: {
    width: 48,
    height: 48,
    top: -26,
    right: 8,
  },
  closeIcon: {
    width: "100%",
    height: "100%",
  },
  content: {
    alignItems: "center",
    paddingHorizontal: 20,
    paddingTop: 30,
    gap: 20,
  },
  modalTitle: {
    color: "#fff",
    fontSize: 22,
    fontWeight: "bold",
  },
  connectText: {
    color: "#ccc",
    fontSize: 16,
    textAlign: "center",
  },
  text: {
    fontSize: 22,
    fontWeight: "900",
    letterSpacing: 1,
    color: "#E0E0E0",
    textShadowColor: "rgba(0, 0, 0, 0.6)",
    textShadowOffset: { width: 0, height: 2 },
    textShadowRadius: 2,
    textTransform: "uppercase",
    paddingBottom: 2,
    textAlign: "center",

    position: "absolute",
    top: "50%",
    left: "50%",
    transform: [{ translateX: -120 }, { translateY: -20 }],
    width: "100%",
  },
});

export default SvaraModal;
